const zh = {
  100000001:'关键信息',
  100000002:'币种简称',
  100000003:'副本创建者',
  100000004:'副本创建时间',
  100000005:'基础信息',
  100000006:'所属公链/协议',
  100000007:'智能合约地址',
  100000008:'发行时间',
  100000009:'发行总量',
  100000010:'流通总量',
  100000011:'市值',
  100000012:'简介',
  100000013:'社媒信息',
  100000014:'官网',
  100000015:'白皮书',
  100000016:'区块链浏览器',
  100000017:'项目评分',
  100000018:'排名',
  100000019:'前',
  100000020:'代码安全',
  100000021:'项目经营',
  100000022:'价格和流动性',
  100000023:'团队治理',
  100000024:'项目成熟度',
  100000025:'社区和社媒',
  100000026:'更新时间',
  100000027:'安全评分',
  100000028:'合约安全评分',
  100000029:'风险项目统计',
  100000030:'合约代码的明细',
  100000031:'购买税',
  100000032:'卖出税',
  100000033:'是否是蜜罐',
  100000034:'是否可再次 Mint',
  100000035:'是否有黑名单',
  100000036:'是否有白名单',
  100000037:'是否反鲸鱼',
  100000038:'是否可更改税率',
  100000039:'是否开源',
  100000040:'是否有隐藏的持有者',
  100000041:'是否可自毁',
  100000042:'是否是代理合约',
  100000043:'是否可以更改余额',
  100000044:'是否可执行外部调用',
  100000045:'是否可重新获取所有权',
  100000046:'是否有交易冷静期',
  100000047:'是否可暂停转账',
  100000048:'所有权未放弃',
  100000049:'是否是可调整的反鲸鱼',
  100000050:'小数位数过多',
  100000051:'公开的Mint和Burn方法',
  100000052:'燃烧代币是否会更新总量',
  100000053:'燃烧代币是否会更新余额',
  100000054:'自转账是否会增加余额',
  100000055:'转出大于余额的代币是否会失败',
  100000056:'余额在转账中未更新',
  100000057:'是否会消耗接收方余额',
  100000058:'调用TransferFrom超过余额时是否会失败',
  100000059:'BurnFrom方法是否会更新总量',
  100000060:'检测代币的购买税。5%以上被认为是高税率',
  100000061:'检测代币的卖出税。5%以上被认为是高税率',
  100000062:'检测代币是否是蜜罐骗局',
  100000063:'检查是否可以铸造更多代币',
  100000064:'检查代币是否有可以限制用户交换或转移代币的黑名单',
  100000065:'检查代币是否具有允许地址绕过任何限制的白名单。',
  100000066:'检查代币是否有反鲸鱼机制',
  100000067:'检查代币是否有税收，并且税收可以由特权角色修改',
  100000068:'检查代币是否已在区块链浏览器上验证',
  100000069:'检查代币是否有可以操纵合约的隐藏所有者，即使所有权似乎已被放弃',
  100000070:'检查代币是否可以自毁',
  100000071:'检查代币是否是将函数调用委托给实现合约的代理合约',
  100000072:'检查代币余额是否可以由特权角色修改',
  100000073:'检查代币是否调用外部合约',
  100000074:'检查代币是否有后门以重新获得所有权',
  100000075:'检查代币是否有转账冷却机制',
  100000076:'检查特权角色是否可以暂停代币交易',
  100000077:'检查所有者权限是否已放弃',
  100000078:'检查代币的反鲸鱼机制是否可以由特权角色修改',
  100000079:'检查‘decimals（）’函数的返回值是否大于或等于5',
  100000080:'检查随机用户调用 mint() 和 burn() 函数是否会回退',
  100000081:'检查调用“burn（）”函数是否会正确更新总量”',
  100000082:"检查调用' burnFrom（）'函数是否会正确更新余额",
  100000083:'检查与交易发起人相同的收件人调用“transfer（）”函数是否会增加发起人的余额',
  100000084:'检查调用金额超过余额的‘transfer（）’函数是否会失败',
  100000085:"调用' transferFrom（）'函数后检查消费者的余额是否有相应的更新",
  100000086:"检查调用' transferFrom（）'函数是否会使用消费者余额",
  100000087:"调用' transferFrom（）'后检查余额是否正确更新，或者如果金额无效，交易是否恢复",
  100000088:"检查调用“burnFrom（）”函数是否会正确更新总量",
  100000089:'检查是否存在造币权',
  100000090:'检查是否存在冻结权',
  100000091:'检查元数据是否可以更改',
  100000092:'致命',
  100000093:'严重',
  100000094:'中度',
  100000095:'轻度',
  100000096:'仅需知',
  100000097:'mint权限是否已放弃',
  100000098:'冻结权限是否已放弃',
  100000099:'是否可以更改代币的元数据',
  100000100:'',
  100000101:'',
  100000102:'',
  100000103:'',
  100000104:'',
  100000105:'',
}
export default zh


// WEBPACK FOOTER //
// ./src/i18n/langs/languageAllen/zh.js